export default __webpack_public_path__ + "static/media/user_male.0cee8c94.png";